import { Nullable } from 'src/core/common/domain/types/types';

export const PushNotificationActions = {
  NAVIGATE: 'Navigate',
} as const;
export type PushNotificationAction = typeof PushNotificationActions[keyof typeof PushNotificationActions];

export const PushNotificationValues = {
  TASKS: 'Tasks',
} as const;
export type PushNotificationValue = typeof PushNotificationValues[keyof typeof PushNotificationValues];

export const PushNotificationSources = {
  FOREGROUND: 'foreground',
  BACKGROUND: 'background',
} as const;
export type PushNotificationSource = typeof PushNotificationSources[keyof typeof PushNotificationSources];

export type PushNotification = {
  title: string;
  body: string;
  action: string;
  value: string;
  id: Nullable<string>;
  notificationId: Nullable<string>;
};

/**
 * Raw FCM data payload as delivered by cordova-plugin-firebasex. Title/body come at the
 * top level on Android, and inside `aps.alert` on iOS. The `custom_*` fields carry the
 * navigation intent. `tap` is true when the notification was tapped (app was in background).
 */
export type FcmDataPayload = {
  title?: string;
  body?: string;
  tap?: boolean | string;
  aps?: { alert?: { title?: string; body?: string } };
  [key: string]: unknown;
};

const asString = (value: unknown): Nullable<string> => (typeof value === 'string' && value.length > 0 ? value : null);

export const parsePushNotification = (data: FcmDataPayload): PushNotification => ({
  title: asString(data?.title) ?? asString(data?.aps?.alert?.title) ?? '',
  body: asString(data?.body) ?? asString(data?.aps?.alert?.body) ?? '',
  action: asString(data?.custom_action) ?? 'unknown',
  value: asString(data?.custom_value) ?? 'unknown',
  id: asString(data?.custom_id),
  notificationId: asString(data?.custom_notification_id),
});
